import Input from "../text-field-input";

interface PhoneInputProps {
    id: string;
    name: string;
    caption: string;
    value: any;
    returnFormattedValue?: boolean;
    errorText?: string;
    className?: string;
    required?: boolean;
    rightAdornments?: React.ReactNode;
    placeholder?: string;
    format?: string;
    disabled?:boolean;
    onChange: (e: any, formattedValue?: string) => void;
}

const formatPhoneNumber = (phone: string) => {
    return phone.replace(/(\d{2})(\d{3})(\d{7})$/g, '$1/$2/$3');
}

const PhoneInput = (props: PhoneInputProps) => {

    const { value, onChange } = props;

    return (
        <Input
            id={props.id}
            name={props.name}
            caption={`${props.caption} ${props.required ? '*' : ''}`}
            className={props.className}
            startAdornment={props.rightAdornments}
            placeholder={props.placeholder ?? '## (###) ### ####'}
            patternFormat={{
                format: props.format ?? '## (###) ### ####',
                mask: '_',
            }}
            errorText={props.errorText}
            disabled={props.disabled}
            value={value}
            onChange={(e: any) => {
                const val = String(e.target.value);
                let formattedValue = (props.returnFormattedValue && val.length === 12) ? formatPhoneNumber(val) : undefined;
                onChange(e, formattedValue);
            }}
        />
    )
}

export default PhoneInput